import { Component } from '@angular/core';
import { EventsService } from '../crud-service';
import { EventsCrudIndex } from './crud-index';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { FormGroup } from '@angular/forms';
import { take } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { filterFields } from '../crud-config';

@Component({
  selector: 'app-events-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [EventsService],
})
export class EventsIndexComponent extends EventsCrudIndex {
  override filterFields: IFieldConfig[] = filterFields;
  ngOnInit(): void {}
  
  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            return item;
          })
        );
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.name) params.name = filter.name.toUpperCase();
    else delete params.name;

    return params;
  }
}
